<ul class="new-theme-typography">
    <li class="breadcrumb-link" *ngFor="let breadcrumb of breadCrumbs$ | async;">
        <a class="breadcrumb-link" [routerLink]="breadcrumb.path">{{ breadcrumb.label }}</a>
        <span class="material-symbols-outlined align-middle pb-px">navigate_next</span>
    </li>
</ul>
